import { api } from '@/shared/api/client';
import type { Content, GetCourseDetailResponse } from '../model/dto';

const normalizeProgressPercent = (
  value: number | null | undefined,
): number | null => {
  if (typeof value !== 'number') {
    return value ?? null;
  }

  if (value < 0) {
    return 0;
  }

  if (value <= 1) {
    const normalized = Math.round(value * 100);
    return normalized > 100 ? 100 : normalized;
  }

  return value;
};

const normalizeContent = (content: Content): Content => ({
  ...content,
  type: content.type ?? content.content_type,
  duration_seconds: content.duration_seconds ?? content.duration_secs,
});

export const getCourseDetail = async (id?: string) => {
  if (!id) {
    throw new Error('Course id is required');
  }

  const { data } = await api.get<GetCourseDetailResponse>(`/courses/${id}/`);

  const durationHours =
    data.duration_hours ??
    (typeof data.duration_secs === 'number'
      ? Number((data.duration_secs / 3600).toFixed(2))
      : undefined);

  const userCourseAssociation = data.user_course_association
    ? {
        ...data.user_course_association,
        progress_percent: normalizeProgressPercent(
          data.user_course_association.progress_percent,
        ),
      }
    : null;

  return {
    ...data,
    duration_hours: durationHours,
    contents: data.contents?.map(normalizeContent) ?? [],
    user_course_association: userCourseAssociation,
  };
};
